<script setup lang="ts">
import { computed } from 'vue';

import { type ReviewWidgetBundle } from '@thehotelsnetwork/personalization-types';

import {
  getTooltipSettings,
  getProviderItems,
  getRankingConfig,
} from './mappers';
import type { ReviewConfig } from './declarations';

const props = defineProps<{
  config: ReviewWidgetBundle;
}>();

const resultConfig = computed<ReviewConfig>(() => ({
  ...props.config,
  calculate: {
    tooltip: getTooltipSettings(props.config),
    providers: getProviderItems(props.config.payload.reviewProviders),
    rankingConfig: getRankingConfig(props.config),
  },
}));
</script>

<template>
  <slot :config="resultConfig" />
</template>
